import { lazyNamed } from 'src/utils/lazyNamed';

const BidReduction = {
  Layout: lazyNamed(() => import('./Layout'), 'Layout'),
  ModelDashboard: lazyNamed(() => import('./ModelDashboard'), 'ModelDashboard'),
  BidReductionConfigsList: lazyNamed(() => import('./BidReductionConfigsList'), 'BidReductionConfigsList'),
};

export default BidReduction;
